import React from "react";
import "../../styles/Conditions.css";

const Conditions = () => {
  return (
    <div className="conditions-container">
      <h3>Conditions That Benefit From Respiratory Muscle Aids</h3>
      <div className="conditions-grid">
        <div className="condition-card">
          <p className="section-title">Muscular Dystrophies</p>
          <ul>
            <li>Dystrophinopathies</li>
            <li>Duchenne</li>
            <li>Becker</li>
            <li>Limb-Girdle</li>
            <li>Emery-Dreifuss</li>
            <li>Facioscapulohumeral</li>
            <li>Congenital</li>
            <li>Childhood Autosomal Recessive</li>
            <li>Myotonic Dystrophy</li>
          </ul>
        </div>

        <div className="condition-card">
          <p className="section-title">Non-Duchenne Myopathies</p>
          <ul>
            <li>Acid Maltase Deficiency</li>
            <li>Polymyositis</li>
            <li>Myasthenia Gravis</li>
            <li>Mixed Connective Tissue Disease</li>
            <li>Cancer, Cachexia, Anorexia Nervosa, medication-associated</li>
          </ul>
        </div>

        <div className="condition-card">
          <p className="section-title">Neurological Disorders</p>
          <ul>
            <li>Spinal Muscular Atrophies</li>
            <li>Motor Neuron Diseases</li>
            <li>Poliomyelitis</li>
          </ul>
        </div>

        <div className="condition-card">
          <p className="section-title">Neuropathies</p>
          <ul>
            <li>Hereditary Neuropathies</li>
            <li>Diaphragm Paralysis</li>
            <li>Guillain-Barré Syndrome</li>
            <li>Multiple Sclerosis</li>
            <li>Friedreich's Ataxia</li>
            <li>Spinal Cord Lesions</li>
            <li>Sleep Breathing Disorders</li>
            <li>Familial Dysautonomia</li>
          </ul>
        </div>

        <div className="condition-card">
          <p className="section-title">
            Skeletal & Connective Tissue Disorders
          </p>
          <ul>
            <li>Kyphoscoliosis</li>
            <li>Osteogenesis Imperfecta</li>
            <li>Rigid Spine Syndrome</li>
            <li>Spondyloepiphyseal Dysplasia Congenita</li>
          </ul>
        </div>

        <div className="condition-card">
          <p className="section-title">
            Restrictive Lung Disease / Lung Resection
          </p>
          <ul>
            <li>Tuberculosis (post-resection/fibrosis)</li>
            <li>Chronic Obstructive Pulmonary Disease (COPD)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Conditions;
